import { Modal } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import SurveyContainer from './surveyContainer';
import { onboardingSurveyClosed, onboardingSurveyViewed } from '../../mixPanelEvents/mixPanelEvents';

type SurveyModalProps = {};

const SurveyModal: React.FC<SurveyModalProps> = () => {
    
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    
    useEffect(() => {
        window.pgPopupActive = 'newWelcomeSurvey';
        // setTimeout(() => {
        //     setModalIsOpen(true);
        //     onboardingSurveyViewed('onboarding');
        // }, 1500);
    }, []);
    const onClose = useCallback(() => {
        setModalIsOpen(false);
        onboardingSurveyClosed('onboarding');
        window.pgPopupActive = null;
    }, [setModalIsOpen]);

    const shouldHideSurvey: boolean = (window.pgUser.products.includes("120") || window.pgUser.products.includes("121")) && window.pgUser.session === 1;
    if (shouldHideSurvey) {
        return null;
        // setModalIsOpen(false);
    }

    return (
        <Modal
            open={modalIsOpen}
            onClose={onClose}
            aria-labelledby='modal-title'
            aria-describedby='modal-description'
            sx={{ paddingBottom: 0 }}
        >
            <SurveyContainer setModalIsOpen={setModalIsOpen} />
        </Modal>
    );
}

export default SurveyModal;